/**
 * mock getFilterConfig接口返回的数据作为兜底
 */

import dUtils from './DateUtils'
let monthObj = {
    text: '',
    value: '',
    areDefault: false,
    areCalendar: false,
    areRadio: false
};

const DEFAULT_WEEKS = ['1', '2', '3', '4', '5', '6', '7'];

const latelyConfigMap = {
    oneway: {
        isInner: [
            {
                text: '未来半年',
                days: 198
            },
            {
                text: '未来2周',
                days: 14
            }
        ],
        isInter: [
            {
                text: '未来半年',
                days: 198
            },
            {
                text: '未来2周',
                days: 14
            }
        ]
    }
};
const monthFilterMap = {
    '未来半年': 'config_1',
    '未来2周': 'config_2'
}

const monthConfigMap = {
    'oneway': [0, 1, 2, 3, 4],
    'roundway': [0, 1, 2, 3, 4]
};

let Utils = {
    getFilterDataSet: function (isRoundWay, isInter) {
        return {
            months: this.getFilterSet(isRoundWay, isInter),
            days: {start: 2, end: 15},
            areInter: false
        };
    },
    /**
     * 获取可使用的filterdata
     * 结构为上面定义的monthObj的结构。
     * @param isRoundWay 是否是往返
     * @param isInter 是否是国际
     * @param needCustom 是否需要自定义
     * @returns {*}
     */
    getFilterSet: function (isRoundWay, isInter, needCustom) {
        let filterData = this.getFilterData(isRoundWay, isInter);
        // 统一为monthObj的结构
        let filterDataSet = filterData.map((filter) => {
            return Object.assign({}, monthObj, filter);
        });

        // 设置除日期外其他默认值
        let filterDataDefaultSet = filterDataSet.map((filter, i) => {
            return Object.assign({}, filter, {
                areDefault: isRoundWay ? i < 3 : i === 0,
                areRadio: !isRoundWay,
                weeks: DEFAULT_WEEKS,
                filterType: monthFilterMap[filter.text] || 'config_3'
            });
        });

        if (needCustom) {
            // concat自定义
            return filterDataDefaultSet.concat(this.getCustomSet(isRoundWay));
        } else {
            return filterDataDefaultSet;
        }
    },

    /**
     * 根据latelyConfigMap 和 monthConfigMap获取日期结构
     * 结构为：[{value:'8月', text:'2019-08-01 | 2019-08-31'}]
     * @param isRoundWay 是否是往返
     * @param isInter 是否是国际
     * @returns {*}
     */
    getFilterData: function (isRoundWay, isInter) {
        let type = isRoundWay ? 'roundway' : 'oneway';
        let nationType = isInter ? 'isInter' : 'isInner';
        let curDate = new Date();
        let latelySettingArr = this.getLatelySetting(curDate, type, nationType);
        let monthSettingArr = this.getMonthSetting(curDate, type);
        return latelySettingArr.concat(monthSettingArr);
    },

    // 根据latelyConfigMap（最近*天、最近*月）获取对应结构
    getLatelySetting: function (curDate, type = 'oneway', nationType = 'isInner') {
        let date = new Date(curDate);
        const latelyConfig = ((latelyConfigMap[type] || {})[nationType]) || [];
        return latelyConfig.map((latelySet) => {
            const {days, text} = latelySet;
            return this.getLatelyDays(date, days, text);
        });
    },

    // 获取最近几天
    getLatelyDays: function (curDate, days, text) {
        let date = new Date(curDate);
        let tag = {
            value: dUtils.dateFormat(date, 'yyyy-MM-dd') + '|' + dUtils.addGoDate(date, days),
            text: text
        };
        return tag;
    },

    // 根据monthConfigMap（当前月+几月）获取对应结构
    getMonthSetting: function (curDate, type = 'oneway') {
        let date = new Date(curDate);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let monthConfig = monthConfigMap[type];
        return monthConfig.map((monthAdd) => {
            let monthNum = month + monthAdd;
            if (monthNum > 12) {
                monthNum = monthNum - 12;
                year = date.getFullYear() + 1;
            }
            return this.getMonthDay(year, monthNum, type);
        });
    },

    // 获取某年，某月 一整个月的对应结构
    getMonthDay: function (year, month, type = 'oneway') {
        month = month === 0 ? 1 : month;
        let date = new Date(year, month - 1, 1);
        let nextMonthDate = new Date(year, month, 1);
        let monthLastDate = dUtils.addGoDate(nextMonthDate, -1);
        let formatDate = dUtils.dateFormat(date, 'yyyy-MM-dd') + '|' + dUtils.dateFormat(monthLastDate, 'yyyy-MM-dd');
        let tagValue = type === 'oneway' ? formatDate : formatDate + ':0';
        let tag = {
            value: tagValue,
            text: month + '月'
        };
        return tag;
    },

    // 用户自定义
    getCustomSet: function (isRoundWay) {
        return [{
            text: '自定义',
            value: isRoundWay ? ':2' : '',
            areDefault: false,
            areCalendar: true,
            areRadio: true
        }];
    }
};

module.exports = Utils;
